"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _Checkbox = require("./Checkbox");

var _Media = require("../Media");

var _Form = require("../../../domains/registration/onboarding/shared/styles/Form");

var __jsx = _react["default"].createElement;

var InputCheckbox = function InputCheckbox(_ref) {
  var label = _ref.label,
      description = _ref.description,
      size = _ref.size,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["label", "description", "size"]);
  var hasDescription = !!description;
  return __jsx(_Checkbox.Checkbox, {
    as: "label",
    center: !hasDescription
  }, __jsx(_Media.MediaObject, {
    $preserveSize: true
  }, __jsx(_formik.Field, (0, _extends2["default"])({
    type: "checkbox"
  }, props)), __jsx(_Form.CheckboxState, {
    $size: size
  })), __jsx(_Media.MediaBody, null, __jsx(_Checkbox.Label, {
    hasDescription: hasDescription
  }, label), hasDescription && __jsx(_Checkbox.Description, null, description)));
};

InputCheckbox.defaultProps = {
  description: ''
};
var _default = InputCheckbox;
exports["default"] = _default;